class tabContent extends HTMLElement {
    constructor() {
        super();
        this.tabButtons = this.querySelectorAll('.product-tab-button');
        this.tabPanels = this.querySelectorAll('.product-tab-panel');
        this.init();
    }

    init() {
        this.tabButtons?.forEach(button => {
            button.addEventListener('click', (event) => this.onTabClick(event));
        });
        this.mangeAccordionLink();
    }

    onTabClick(event) {
        const clickedButton = event.target;

        this.tabButtons?.forEach(button => button.classList.remove('active'));
        this.tabPanels?.forEach(panel => panel.classList.remove('active'));

        clickedButton.classList.add('active');
        const targetPanel = this.querySelector(`#${clickedButton.dataset.tab}`);

        targetPanel?.classList.add('active');

        if (window.innerWidth < 768 && this.querySelector('details')) {
            if (this.querySelector('details').hasAttribute('open')) {
                this.querySelector('details')?.removeAttribute('open');
            } else {
                this.querySelector('details')?.setAttribute('open', '');
            }
            this.querySelector('details summary .summary__title p').innerHTML = clickedButton.innerHTML;
        }
    }

    mangeAccordionLink() {
        document.querySelector(".product-details [href='#artwork']")?.addEventListener('click', () => {
            if (window.innerWidth >= 768 && this.querySelector('details')) {
                this.querySelector('.desktop-tabs .product-tab-button[data-tab="artwork"]')?.click();
            }

            if (window.innerWidth < 768 && this.querySelector('details')) {
                this.querySelector('.mobile-tabs .product-tab-button[data-tab="artwork"]')?.click();
                this.querySelector('details')?.removeAttribute('open');
            }
        });
    }
}

customElements.define('tab-content', tabContent);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
                if(event.target.classList.contains('modal-content')) {
                    this.hide();
                }
            });
        }
    }

    show(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        document.body.style.height = '100vh';
        this.setAttribute('open', '');
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.style.height = '';
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
    }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}

customElements.define('modal-opener', ModalOpener);

// DEPLOY_MARKER_20260720_V2 — cart notes fix pipeline test
// Persist the cart order note to the cart as the customer types.
// Without this the note is only sent when the built-in Checkout button
// submits the cart form, so accelerated checkout buttons (Shop Pay, PayPal,
// etc.) or any other path to checkout lose it — leaving orders with
// "No notes from customer". Delegated + debounced so it survives the cart's
// AJAX re-renders.
(function () {
    let timer;

    const saveNote = (value) => {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: value })
        });
    };

    document.addEventListener('input', (event) => {
        if (event.target && event.target.id === 'cart-note') {
            clearTimeout(timer);
            const value = event.target.value;
            timer = setTimeout(() => saveNote(value), 500);
        }
    });

    // Catch the fast clicker who types then immediately hits checkout.
    document.addEventListener('blur', (event) => {
        if (event.target && event.target.id === 'cart-note') {
            clearTimeout(timer);
            saveNote(event.target.value);
        }
    }, true);
})();
